/**
 * @author Vivek Kumar <vivek.kumar@314ecorp.com>
 * @description Shared account collapse header used across the allocation editor/summary tables.
 */
import { Link } from 'react-router-dom';
import _ from 'lodash';
import { Flex, Tag, Typography } from 'antd';

import { formatAmount } from 'utils/accounts/allAccounts';
import { getAccountDetailsPath } from 'utils/router';

interface IProps {
	accountNumber?: string;
	accountAge?: number;
	outstandingPR: number;
	accountId?: string;
}

const AccountCollapseHeader: React.FC<IProps> = ({ accountNumber, accountAge, outstandingPR, accountId }) => {
	const display = _.isEmpty(accountNumber) ? <i>{'No Account Number'}</i> : _.toUpper(accountNumber);
	const outstandingColor = outstandingPR > 0 ? 'warning' : 'success';
	const title = accountId ? (
		<Link target='_blank' to={getAccountDetailsPath(accountId)}>
			{display}
		</Link>
	) : (
		<Typography.Text>{display}</Typography.Text>
	);

	return (
		<Flex justify='space-between' align='center' className='payment-allocation-account-collapse-header'>
			<Flex align='center' gap={8}>
				{title}
				{!!accountAge && <Tag color='default'>{`${accountAge} days`}</Tag>}
			</Flex>
			<Typography.Text type={outstandingColor}>
				{'Outstanding PR: '}
				{formatAmount(outstandingPR)}
			</Typography.Text>
		</Flex>
	);
};

export default AccountCollapseHeader;
